// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage, defineMessages } from "react-intl";

export const WelcomeText = (): ReactElement => (
    <FormattedMessage
        id="apps.core.components.welcomeText"
        description="Welcome text."
        defaultMessage="Welcome to My Lenses"
    />
);
WelcomeText.displayName = "WelcomeText";

export const GetStartedText = (): ReactElement => (
    <FormattedMessage
        id="apps.core.components.getStartedText"
        description="Get started text."
        defaultMessage="In order to get started with My Lenses, you need to submit a lens!"
    />
);
GetStartedText.displayName = "GetStartedText";

export const DocsLinkText = (): ReactElement => (
    <FormattedMessage
        id="apps.core.components.docsLinkText"
        description="Docs link text."
        defaultMessage="Learn How to Create and Submit Your First Lens"
    />
);
DocsLinkText.displayName = "DocsLinkText";

export const MembershipNote = (props: { link: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.core.components.membershipNote"
        description="Membership note."
        defaultMessage="If your organization already has lenses, you may not have permission to manage them. Check your organization membership settings in {link}."
        values={props}
    />
);
MembershipNote.displayName = "MembershipNote";

export const DefaultMembershipMessage = (props: { link: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.core.components.defaultMembershipMessage"
        description="Default membership message."
        defaultMessage="Check your Organization Membership settings in {link} or select a different Organization."
        values={props}
    />
);
DefaultMembershipMessage.displayName = "DefaultMembershipMessage";

export const BusinessManagerLinkText = (): ReactElement => (
    <FormattedMessage
        id="apps.core.components.businessManagerLinkText"
        description="Business manager link text."
        defaultMessage="Business Manager"
    />
);
BusinessManagerLinkText.displayName = "BusinessManagerLinkText";

export const LensFoldersNotAvailalble = (): ReactElement => (
    <FormattedMessage
        id="apps.core.components.lensFoldersNotAvailalble"
        description="Lens folders not availalble."
        defaultMessage="Lens Folders are not available"
    />
);
LensFoldersNotAvailalble.displayName = "LensFoldersNotAvailalble";

export const LensInsightsNotAvailalble = (): ReactElement => (
    <FormattedMessage
        id="apps.core.components.lensInsightsNotAvailalble"
        description="Lens insights not availalble."
        defaultMessage="Lens Insights are not available"
    />
);
LensInsightsNotAvailalble.displayName = "LensInsightsNotAvailalble";

export const messages = defineMessages({
    openNavigationMenuAriaText: {
        id: "apps.core.components.openNavigationMenuAriaText",
        description: "Open navigation menu aria text.",
        defaultMessage: "Open navigation menu",
    },
    closeNavigationMenuAriaText: {
        id: "apps.core.components.closeNavigationMenuAriaText",
        description: "Close navigation menu aria text.",
        defaultMessage: "Close navigation menu",
    },
});
